import React from "react";
import DatePicker from "react-datepicker";
import {useField, useFormikContext} from "formik";
import {useTranslation} from "react-i18next";
import {endOfDay} from "../../../helpers/DateTimeHelper";

interface FormikDatePickerProps {
    name: string;
    placeholderText: string;
    minDate?: Date | null;
    maxDate?: Date | null;
    // Adds an hour:minute input; the picked value is in the browser's time zone (see DateTimeHelper).
    showTime?: boolean;
    // For "to" fields: a freshly picked day defaults to 23:59 instead of 00:00.
    endOfDayDefault?: boolean;
}

export const FormikDatePicker: React.FC<FormikDatePickerProps> = ({ name, minDate, maxDate, showTime = false, endOfDayDefault = false, ...props }: FormikDatePickerProps) => {
    const {t} = useTranslation();
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);

    const handleChange = (val: Date | null) => {
        if (val && showTime && endOfDayDefault && !field.value) {
            val = endOfDay(val);
        }
        setFieldValue(name, val);
    };

    return (
        <div>
            <DatePicker
                className="form-control"
                {...field}
                {...props}
                selected={field.value}
                autoComplete="off"
                onChange={handleChange}
                dateFormat={showTime ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
                showTimeInput={showTime}
                timeInputLabel={`${t('Time')}:`}
                minDate={minDate ?? undefined}
                maxDate={maxDate ?? undefined}
            />
            {meta.touched && meta.error ? (
                <div style={{ color: "red", fontSize: "12px" }}>{meta.error}</div>
            ) : null}
        </div>
    );
};
